import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useConfig } from "@/hooks/useConfig";
import { IMAGES, COMPANY } from "@/lib/site";
import { euro } from "@/lib/api";

export default function Services() {
  const { config } = useConfig();
  const services = config?.services || [];

  return (
    <div data-testid="services-page" className="pt-32">
      <section className="mx-auto max-w-7xl px-5 lg:px-10">
        <Reveal>
          <p className="text-gold text-xs tracking-[0.4em] uppercase">Prestations</p>
          <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl text-white">Nos Services & Tarifs</h1>
          <p className="mt-5 max-w-2xl text-white/60">
            Des prestations sur mesure, des tarifs transparents en euros TTC. Réservez et payez en ligne en toute sérénité.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-5 lg:px-10 py-16 lg:py-20">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 0.1}>
              <div
                data-testid={`service-card-${s.id}`}
                className="group flex flex-col h-full rounded-xl border border-white/10 bg-panel p-8 transition-transform duration-300 hover:-translate-y-1 hover:border-gold/40"
              >
                <div className="flex items-baseline justify-between">
                  <h3 className="text-xl text-white">{s.title}</h3>
                </div>
                <p className="mt-3 text-sm text-white/55 leading-relaxed flex-1">{s.desc}</p>
                <div className="mt-6 flex items-end gap-2">
                  <span className="text-xs text-white/40">à partir de</span>
                  <span className="gold-text font-serif text-3xl">{euro(s.price_from)}</span>
                  <span className="text-xs text-white/40">/ {s.unit}</span>
                </div>
                <Link
                  to={s.id === "longdistance" ? "/devis" : `/reservation?service=${s.id}&trip=${s.trip_type}&vehicle=${s.vehicle}`}
                  data-testid={`service-book-${s.id}`}
                  className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-gold px-6 py-3 text-sm font-medium text-black transition-colors duration-300 hover:bg-goldsoft"
                >
                  {s.id === "longdistance" ? "Demander un devis" : "Réserver ce service"} <ArrowRight size={16} />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 lg:px-10 pb-24 grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <img src={IMAGES.airport} alt="Transfert aéroport de luxe" className="rounded-xl w-full h-[420px] object-cover" />
        </Reveal>
        <Reveal delay={0.15}>
          <div>
            <h2 className="font-serif text-3xl lg:text-4xl text-white">Inclus dans chaque prestation</h2>
            <ul className="mt-8 space-y-4">
              {[
                "Chauffeur professionnel en tenue",
                "Suivi de vol & accueil personnalisé",
                "Eau, presse et chargeurs à bord",
                "Attente offerte (30 min sur transferts aéroport)",
                "Paiement 100% sécurisé en ligne",
                "Assistance & disponibilité " + COMPANY.hours,
              ].map((t) => (
                <li key={t} className="flex items-start gap-3 text-white/70">
                  <span className="mt-0.5 grid h-5 w-5 place-items-center rounded-full bg-gold/15 text-gold"><Check size={13} /></span>
                  {t}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
